import { render } from "./TransitionScreen.vue?vue&type=template&id=ab0c4598"
const script = {}

import "./TransitionScreen.vue?vue&type=style&index=0&id=ab0c4598&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__